<template>
  <div id="app">
    <users></users>
  </div>
</template>

<script>
import users from './components/Users.vue'

export default {
  components : {
    users
  },

  data() {
    return {
    }
  }
}
</script>

<style>
</style>
